<template>
    <input type="hidden" name="expectedOutput" :value="output">
</template>

<script>
import Vue from 'vue';
import OutputBuffer from '@/services/OutputBuffer';

export default {
    name: "ExerciseInput",

    props: {
        terminalBus: {
            type: Vue,
            required: true
        }
    },

    data () {
        return {
            outputBuffer: undefined,
            output: undefined
        }
    },

    mounted () {
        this.outputBuffer = new OutputBuffer(this.terminalBus, output => {
            this.output = output
        })
    }
}
</script>

